import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import BrandPage from "./BrandPage";
import ExpandedBrandPage from "./ExpandedBrandPage";
import BrandListing from "./BrandListing";
import OurBrands from "./OurBrands";
import BrandGroupPage from "./BrandGroupPage";

whenDomReady(() => {
  if (document.querySelector('[data-hypernova-key="BrandPage"]')) {
    renderFromPreloadedJSON(BrandPage, "BrandPage");
  }
  if (document.querySelector('[data-hypernova-key="BrandGroupPage"]')) {
    renderFromPreloadedJSON(BrandGroupPage, "BrandGroupPage");
  }
  if (document.querySelector('[data-hypernova-key="ExpandedBrandPage"]')) {
    renderFromPreloadedJSON(ExpandedBrandPage, "ExpandedBrandPage");
  }
  if (document.querySelector('[data-hypernova-key="BrandListing"]')) {
    renderFromPreloadedJSON(BrandListing, "BrandListing");
  }
  if (document.querySelector('[data-hypernova-key="OurBrands"]')) {
    renderFromPreloadedJSON(OurBrands, "OurBrands");
  }
});

whenDomReady(async () => {
  if (document.querySelector("[data-component=carousel]")) {
    const { default: initCategoryCarousels } = await import(
      "~/common/initCategoryCarousels"
    );
    initCategoryCarousels();
  }
});
